import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import PinballMachineIcon from './PinballMachineIcon';
import './BottomNavShell.css';
import './MachineBottomNav.css';
import { DSIcon } from '../design-system/primitives';

const SUB_PATHS = ['/machines/issues', '/machines/triage', '/machines/maintenance'];

const MACHINES_TAB = {
  path: '/machines',
  icon: <PinballMachineIcon size={20} />,
  label: 'Machines',
  match: (p) => p === '/machines' || (p.startsWith('/machines/') && !SUB_PATHS.some((sp) => p.startsWith(sp)))
};

// Viewing tickets is universal regardless of tier (docs/MACHINE_TICKET_TIERING_
// REQUIREMENTS.md §10/§13) - every tier including Tier 0 can browse the Issues
// tab read-only, so it's never gated.
const ISSUES_TAB = { path: '/machines/issues', icon: <DSIcon name="wrench" />, label: 'Issues', match: (p) => p.startsWith('/machines/issues') };

// Triage is Tier 3+/Admin (docs/MACHINE_TICKET_TIERING_REQUIREMENTS.md §8) -
// the Issues tab's own "Assigned To: My Issues" filter (combined with
// grouped/ungrouped browsing) now covers the "what can I work on" case that
// used to be a separate Queue tab.
const TRIAGE_TAB = { path: '/machines/triage', icon: <DSIcon name="warning" />, label: 'Triage', match: (p) => p.startsWith('/machines/triage') };

// Unlike Issues/Queue/Triage, every tier including Tier 0 can view the
// needs-maintenance list and their own assigned records (doc §11), so this
// tab is never tier-gated - only the actions inside the pages themselves are.
const MAINTENANCE_TAB = { path: '/machines/maintenance', icon: <DSIcon name="wrench" />, label: 'Maintenance', match: (p) => p.startsWith('/machines/maintenance') };

function MachineBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = authService.getCurrentUser();
  const isAdmin = currentUser?.role === 'admin';
  const techTier = currentUser?.techTier ?? currentUser?.tech_tier ?? 0;
  const canTriage = isAdmin || techTier >= 3;

  const tabs = [
    MACHINES_TAB,
    ISSUES_TAB,
    ...(canTriage ? [TRIAGE_TAB] : []),
    MAINTENANCE_TAB
  ];

  return (
    <nav className="bn-shell mbn-bottomnav">
      {tabs.map((tab) => {
        const isActive = tab.match(location.pathname);
        return (
          <button
            key={tab.label}
            type="button"
            className={`bn-shell-item mbn-bottomnav-item ${isActive ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <span className="bn-shell-icon mbn-bottomnav-icon">{tab.icon}</span>
            <span className="mbn-bottomnav-label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default MachineBottomNav;
